angular.module('impactx.address').controller('AddressInputCtrl', ['$scope', '$mdDialog', '$filter', 'dataGen', 'TranslationService', AddressInputCtrl]);

function AddressInputCtrl($scope, $mdDialog, $filter, dataGen, TranslationService) {
    var ctrl = this;
    ctrl.searchText = "";
    $scope.showedOneTime = false;
    var idForFilterMore = -3;

    this.addressIsEmpty = function (item)
    {
        return ((item.name1 == undefined || item.name1.value == undefined) &&
            (item.name2 == undefined || item.name2.value == undefined) &&
            (item.name3 == undefined || item.name3.value == undefined) &&
            (item.street1 == undefined || item.street1.value == undefined) &&
            (item.zip == undefined || item.zip.value == undefined) &&
            (item.city == undefined || item.city.value == undefined)) &&
            (item.eMail == undefined || item.eMail.value == undefined);
    };
    
    this.showAddressDialog = function(event, selected, restricted) {
        $mdDialog.show({
            templateUrl: 'modules/address/templates/addressdialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            controller: "AddressDialogCtrl",
            controllerAs: 'ctrl',
            hasBackdrop: true,
            disableParentScroll: true,
            multiple: true,
            locals: {
                data: selected,
                trns: $scope.trns,
                label_title: $scope.labelTitle,
                addressType: $scope.addressType,
                typesAvail: $scope.availTypes,
                showInheritanceOptions: $scope.showInheritanceOptions,
                owningComOptions: $scope.owningComOptions,
                disableOwningCom: $scope.disableOwningCom,
                saveDirect: $scope.saveDirect,
                personalData: $scope.personalData,
                addresses: $scope.addresses,
                restricted: restricted,
                regionCode: $scope.regionCode
            }
        }).then(function(answer) {
            if(!isUndefined(answer) && !isUndefined(answer.addressId)) {
                var found = false;
                for(var i = 0; i < $scope.addresses.entries.length; i++) {
                    if($scope.addresses.entries[i].addressId === answer.addressId) {
                        found = true;
                        break;
                    }
                }
                if(!found) {
                    $scope.addresses.entries.push(answer);
                }
                $scope.selected = answer;
                $scope.onChange($scope.selected, $scope.addressType);
            }
        });
    };

    this.getEntries = function () {
        if (!$scope.entryPoint) {
            return $filter('filter')($scope.addresses.entries, ctrl.searchText);
        }
        else {
            var dataObject = {searchText: ctrl.searchText, addressType: $scope.addressType};
            if ($scope.additionalDataForEntryPoint) {
                angular.forEach(Object.keys($scope.additionalDataForEntryPoint), function (key) {
                    dataObject[key] = $scope.additionalDataForEntryPoint[key];
                });
            }
            return dataGen.getData({}, dataObject, $scope.entryPoint, null, true).then(function (data) {
                if (!data.data) {
                    return [];
                }
                return ctrl.extractData(data);
            });
        }
    };

    this.extractData = function (data) {
        var results = data.data.entries;
        if (data.data.hasMoreResults) {
            results.push({id: idForFilterMore, value: TranslationService.get("hasMoreResults")});
        }
        handleOneResult(data.data.entries);
        return results;
    };

    $scope.loadMore = function (event, item) {
        if (item.id < 0) {
            event.stopPropagation();
        }
    };

    function handleOneResult(results) {
        if ($scope.selectIfOne) {
            if (results.length == 1) {
                $scope.$applyAsync(function () {
                    $scope.selected = results[0];
                    inputBlur();
                });
            }
        }
    }

    function inputBlur() {
        var focusedElement = document.activeElement;

        if (focusedElement) {
            focusedElement.blur();
        }
    }
}